import React from 'react'
import { PropsWithChildren } from 'react'
import { wrap } from '../../../utils/globalUtils'
import useActivationObjectProvider from './hooks/useActivationObjectProvider'
import { useActivationObjectProviderProps } from './types'
import ActivationObjectProviderView from './views/ActivationObjectProviderView'

const ActivationObjectProvider: React.FC<PropsWithChildren<useActivationObjectProviderProps>> = wrap(
    ActivationObjectProviderView,
    useActivationObjectProvider
)
export default ActivationObjectProvider
